export default function() {
  return [
    {
      title: "Public Blog",
      to: "/blogs/public",
      htmlBefore: '<i class="material-icons">language</i>',
      htmlAfter: ""
    },
    {
      title: "Member Content",
      htmlBefore: '<i class="material-icons">view_quilt</i>',
      to: "/blogs/premium/"
    },
    {
      title: "Alerts",
      htmlBefore: '<i class="material-icons">notification_important</i>',
      to: "/alerts"
    },
    {
      title: "Analysts",
      htmlBefore: '<i class="material-icons">people</i>',
      to: "/analysts"
    },
    {
      title: "Education",
      htmlBefore: '<i class="material-icons">book</i>',
      to: "/education"
    },
    {
      title: "FAQ",
      htmlBefore: '<i class="material-icons">contact_support</i>',
      to: "/faq"
    },
    {
      title: "4-Year Journey",
      htmlBefore: '<i class="material-icons">timeline</i>',
      to: "/4yearcycle"
    },
    {
      title: "CMS",
      htmlBefore: '<i class="material-icons">note_add</i>',
      to: "/cms"
    },
    {
      title: "Admin",
      htmlBefore: '<i class="material-icons">settings</i>',
      to: "/admin"
    }
  ];
}
